export default __webpack_public_path__ + "static/media/livingroom2.d598cc14.webp";